import jwtDecode from 'jwt-decode'
import 'regenerator-runtime/runtime';

const checkAuth = () => {
  var token = localStorage.getItem('token')
  if (!token) {
    localStorage.clear()
    return false
  }
  var decoded = jwtDecode(token);
  if (new Date() > new Date(decoded.expires))
    localStorage.clear()

  return new Date() < new Date(decoded.expires)
}

const getAuthHeader = () => {
  return {
    'Authorization': 'Bearer ' + localStorage.getItem('token')
  }
}

const getAuth = () => {
  var token = localStorage.getItem('token')
  return jwtDecode(token);
}

const showDialogError = (context, message) => {
  context.$dialog.alert({
    title: 'Error',
    message,
    type: 'is-danger',
    hasIcon: true,
    icon: 'times-circle',
    iconPack: 'fa'
  })
}

const getUserById = (idUser) => {
  let users = JSON.parse(localStorage.getItem("users"));
  return users.find(user => user.id === idUser)
}

const getCategories = () => {
  let categories = JSON.parse(localStorage.getItem("categories"));
  return categories
}

const getStatusOrders = () => {
  let statusOrders = [{id: 'pen', name: 'Pendiente'},
    {id: 'apr', name: 'Aprobado'},
    {id: 'ent', name: 'Entregado'},
    {id: 'dev', name: 'Devuelto'},
    {id: 'can', name: 'Cancelado'},
    {id: 'entobs', name: 'Entregado  con observaciones'},
  ]
  return statusOrders
}

const getStatusPickups = () => {
  let statusOrders = [
    {id: 'pen', name: 'Pendiente'},
    {id: 'apr', name: 'Aprobado'},
    {id: 'recog', name: 'Recogido'},
    {id: 'can', name: 'Cancelado'},]
  return statusOrders
}

const getStatusDigitalization = () => {
  let statusOrders = [
    {id: 'req', name: 'Requerido'},
    {id: 'comp', name: 'Completado'},
    {id: 'dis', name: 'Desaprobado'},
    {id: 'can', name: 'Cancelado'},]
  return statusOrders
}

const getStatusFiles = () => {
  let statusFiles = [
    {id: 'stock', name: 'En stock'},
    {id: 'req', name: 'Requerido'},
    {id: 'pickup', name: 'Requiere recogida'},
    {id: 'trans', name: 'En transporte'},
    {id: 'transpickup', name: 'En recogida de transporte'},
    {id: 'remov', name: 'Removido'},
    {id: 'out', name: 'En cliente'},
  ]
  return statusFiles
}


const getUsers = () => {
  let users = JSON.parse(localStorage.getItem("users"));
  return users
}

const getUser = () => {
  let user = JSON.parse(localStorage.getItem("user"));
  return user
}

const getClient = () => {
  let client = JSON.parse(localStorage.getItem("client"));
  return client
}

const getClientAddress = () => {
  let client = JSON.parse(localStorage.getItem("client"));
  if (!client)
    return []

  if (client.addresses) {
    let addressList = []
    client.addresses.forEach(dic => {
      addressList.push(`${dic.description} - ${dic.district}`)
    })
    return addressList
  } else {
    return []
  }

}

const getClassStatusOrder = (value) => {
  if (!value) return ''
  if (value === 'pen' || value === 'envobs' || value === 'entobs')
    return 'is-warning'
  else if (value === 'apr' || value === 'env')
    return 'is-info'
  else if (value === 'ent')
    return 'is-success'
  else if (value === 'can')
    return 'is-danger'
  else return ''
}

const getClassStatusPickup = (value) => {
  if (!value) return ''
  if (value === 'pen')
    return 'is-warning'
  else if (value === 'apr')
    return 'is-info'
  else if (value === 'recog')
    return 'is-success'
  else if (value === 'can')
    return 'is-danger'
  else return ''
}

const getClassSeEnvio = (confirm) => {
  if (confirm == null)
    return 'null'
  else if (confirm === true)
    return 'is-success'
  else if (confirm === false) return 'is-danger'
}

const getTextSeEnvio = (confirm) => {
  if (confirm == null)
    return 'null'
  else if (confirm === true)
    return 'Si'
  else if (confirm === false) return 'No'
}

const getAddresses = (id) => {
  let addresses = getClient().addresses;
  let addresse = addresses.find(item => item.id === id);
  return addresse;
}

const getParametro = (tipo) => {
  let parametro = JSON.parse(localStorage.getItem("parametros"));
  let parametrofilter = parametro.filter(item => item.tipo === tipo);
  return parametrofilter;
}

const getParametroParam = (tipo, param) => {
  let parametro = JSON.parse(localStorage.getItem("parametros"));
  let parametrofilter = parametro.find(item => item.tipo === tipo && item.valor === param);
  return parametrofilter;
}

const getParametroHijo = (tipo, codPadre) => {
  let parametro = JSON.parse(localStorage.getItem("parametros"));
  let parametrofilter = parametro.filter(item => item.tipo === tipo && item.codPadre === codPadre);
  return parametrofilter;
}

const getDepartaments = () => {
  let departaments = JSON.parse(localStorage.getItem("departaments"));
  return departaments;
}

const getProvinces = (codeDepartament) => {
  let provinces = JSON.parse(localStorage.getItem("provinces"));
  let provincesFilter = provinces.filter(c => c.codeDepartament === codeDepartament)
  return provincesFilter;
}

const getDistricts = (codeDepartament, codeProvince) => {
  let districts = JSON.parse(localStorage.getItem("districts"));
  let districtsFilter = districts.filter(c => c.codeDepartament === codeDepartament && c.codeProvince === codeProvince)
  return districtsFilter;
}

const getAuthHeaderMultipart = () => {
  return {
    'Authorization': 'Bearer ' + localStorage.getItem('token'),
    'content-type': 'multipart/form-data'
  }
}

const getClassStatusFile = (value) => {
  if (!value) return "";

  if (["stock"].includes(value)) return "is-success";
  else if (["req", "pickup"].includes(value)) return "is-info";
  else if (["trans", "transpickup", "out"].includes(value)) return "is-warning";
  else if (["remov"].includes(value)) return "is-danger";
  else return "";
}

export default {
  checkAuth,
  getAuthHeader,
  getAuth,
  showDialogError,
  getUserById,
  getCategories,
  getStatusOrders,
  getStatusPickups,
  getStatusDigitalization,
  getStatusFiles,
  getUsers,
  getClient,
  getUser,
  getClientAddress,
  getClassStatusOrder,
  getClassStatusPickup,
  getClassSeEnvio,
  getTextSeEnvio,
  getAddresses,
  getParametro,
  getParametroHijo,
  getParametroParam,
  getDepartaments,
  getProvinces,
  getDistricts,
  getAuthHeaderMultipart,
  getClassStatusFile
}



// WEBPACK FOOTER //
// ./src/util/index.js